import React, {useState,useEffect} from 'react';
import './course-page.styles.scss';
import Loading from "../../../components/loading/loading.component";
import CourseForm from "../../../components/course-form/course-form.component";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { GlobalState } from "../../../redux/root-reducer";
import { fetchApi } from "../../../redux/fetch/fetch.actions";
import {
    ICreateCoursePayload,
} from "../../../redux/course/course.actions";
import QuizActionAPI from "../../../redux/quiz/quiz.actions";
import { useHistory } from "react-router-dom";

interface IProps {
    isFetching?: boolean;
    createCourses: (data: ICreateCoursePayload["data"]) => void;
    clearQuizzes: () => void;
}

const CoursePage = ({isFetching,createCourses,clearQuizzes}:IProps) => {
    
const [course, setCourse] = useState({
    course_name: ''
});

const handleChange = (evt: any, name: string) => {
    let val = evt.target.value;
    setCourse((prevState) => ({
        ...prevState,
        [name]: val,
    }));
};

const handleClick = async (evt: any) => {
    evt.preventDefault();
    createCourses(course);
    
};
const history = useHistory();

useEffect(() => {
    if (isFetching) return;
});

useEffect(() => {
    console.log(isFetching);
    if (isFetching === false) {
        history.replace("/quiz/create");
        window.location.reload();
    } 
    return () => {
        clearQuizzes();
    };
}, [isFetching,history,clearQuizzes]);

    return (
        <div className="container">
            {isFetching ? (
                <Loading className="fixed" />
            ) : (
                <div className="container__content">
                    <CourseForm
                        course={course}
                        handleClick={handleClick}
                        handleChange={handleChange}
                    />
                </div>
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
}: GlobalState) => ({
    isFetching: isFetching.CREATE_COURSE,
    errors: errors.CREATE_COURSE,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    createCourses: (data: ICreateCoursePayload["data"]) =>
        dispatch(fetchApi({ name: "CREATE_COURSE", data })),
    clearQuizzes: () => dispatch(QuizActionAPI.clearQuizzes()),
})

export default connect(mapStateToProps,mapDispatchToProps)(CoursePage);